import { FormFields, ValidationValue, Validator } from 'types/validation'

export const MIN_NAME_LENGTH = 2

export const VALIDATION_ERRORS_ENUM = {
  SHORT_NAME: `Invalid name: minimum length ${MIN_NAME_LENGTH}.`,
  WRONG_SYMBOLS: `Invalid name. Only letters, dash ("-") and apostrophe (') characters are allowed.`,
  CANNOT_BE_EMPTY: 'This field is required.',
}

const nameValidators: Validator[] = [
  {
    name: 'Field cannot be empty',
    isValid: ({ value, isRequired }: ValidationValue): boolean => !isRequired || (isRequired && !!value),
    errorMessage: VALIDATION_ERRORS_ENUM.CANNOT_BE_EMPTY,
  },
  {
    name: 'Check on allowed characters',
    isValid: ({ value, isRequired }: ValidationValue): boolean => {
      if (value) {
        const check = value.match(/[a-zA-Z'\-\s]+/gm)
        const isCorrect = check && check.length === 1 && check[0].length === value.length

        return (isRequired && isCorrect) || (!isRequired && !value) || (!isRequired && isCorrect && !!value)
      }

      return !isRequired
    },
    errorMessage: VALIDATION_ERRORS_ENUM.WRONG_SYMBOLS,
  },
]

export const validateName = (formFields: FormFields, value: ValidationValue): string => {
  const result = nameValidators.reduce((result: string[], validator: Validator) => {
    const errorMessage = !validator.isValid(value) && validator.errorMessage

    errorMessage && result.push(errorMessage)

    return result
  }, [])

  return result.length ? result[0] : ''
}
